import { useTranslation } from "react-i18next";
import { IContentAppealExpiryProps } from "../../model/interface";
import { Input, Label } from "@fluentui/react-components";
import { Warning24Regular, Warning32Filled } from '@fluentui/react-icons';
import Alert from "../alert/alert";
import AppealExpiryAlertBody from "../appealAlertBody/AppealExpiryLandingBody";
import './ContentAppealExpiry.scss';

export default function ContentAppealExpiry(props: IContentAppealExpiryProps) {
    const { t } = useTranslation();

    return (
        <div>
            <div className="form-overview__expiry" role="alert">
                <div><Warning32Filled /></div>
                <h1 className="form-overview__header"> {t('Appeal.Common.expiry-header')}</h1>
                <p className="form-overview__paragraph"> {t('Appeal.Common.expiry-sub-header')}</p>
            </div>
            <div className="form-fields">
                <div className="policy-violation-expiry">
                    <Label id="policyViolationExpiryLabel">{t('Appeal.Common.policy-violated')}</Label>
                    <Input
                        id="policyViolationExpiry"
                        aria-labelledby="policyViolationExpiryLabel"
                        type="text"
                        disabled
                        value={props.policyViolated ? props.policyViolated : t('Appeal.Common.policy-violated')}
                    />
                </div>
                <div className="appeal-eligibility-period">
                    <Label id="eligibilityPeriodExpiryLabel">{t('Appeal.Common.appeal-eligiblity-period')}</Label>
                    <Input
                        id="appealEligiblityPeriod"
                        aria-labelledby="eligibilityPeriodExpiryLabel"
                        data-testid="appealEligiblityPeriod"
                        type="text"
                        disabled
                        value={props.appealEligibilityPeriod ? props.appealEligibilityPeriod : t('Appeal.Common.appeal-eligiblity-period')}
                    />
                </div>
            </div>
            <div className="appeal-dispute">
                <Alert icon={<Warning24Regular />} title={t('Appeal.Common.dispute-line-one')} body={<AppealExpiryAlertBody />} />
            </div>
        </div>
    );
};
